module.exports = __webpack_public_path__ + "assets/img/Business Park.bc0d08ee.png";